var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4910150761581665181(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.1 29.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M4.2 18.8l-.5.4 6.8.8c1 .4 2 .7 3.1.8.4-3.5 4-6.2 8.5-6.2 1.8 0 3.5.4 4.9 1.2.9-1.3 1.4-2.8 1.4-4.4 0-5.3-5.5-9.5-12.2-9.5C9.4 2 3.9 6.3 3.9 11.6c0 1.9.7 3.7 2 5.3l.1.1c-.1.3-1 1.1-1.8 1.8zM8 7.3h16v.9H8v-.9zm0 3.2h16v.9H8v-.9zm0 3.3h8.5v.9H8v-.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M14.3 21.4c0 3.3 3.5 6 7.8 6 1 0 1.9-.1 2.8-.4l.2-.1 2.2 2V26l.1-.1c1.6-1.1 2.5-2.8 2.5-4.4 0-3.3-3.5-6-7.8-6-4.3-.1-7.8 2.6-7.8 5.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#82BFAB",
    d: "M8 7.3h16v.9H8zM8 10.5h16v.9H8zM8 13.8h8.5v.9H8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4910150761581665181);
export default __webpack_public_path__ + "static/media/4910150761581665181.9cdccaa83cc518b4b165f479aaaf229e.svg";
export { ForwardRef as ReactComponent };